import axios from 'axios';
import { getProject } from './gcloud/getProject';

export default async function deleteUserService(email, projectUrl = getProject(), httpRequest = axios) {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  };

  const body = { email }

  return await httpRequest({
    url: `${projectUrl}/deleteUserV2`,
    method: 'POST',
    headers: config,
    data: JSON.stringify(body)
  })
}